import { getSubdomain } from 'tldts';

export const addThemeParamsToUrl = (
  urlString: string,
  currentBrowserUrl: string = globalThis.location.href,
) => {
  const subdomain = getSubdomain(currentBrowserUrl)?.split('.')[0];
  if (!subdomain) {
    return urlString;
  }

  const url = new URL(urlString);
  url.searchParams.append('theme', subdomain);

  return url.toString();
};
